import _ from 'lodash';
import api from '@/api';
import { actions as stageTableActions } from '../WorkOrderReference.redux';

const initialState = {
	loggedEmpId: null,
	currentStageID: null,
	currentTableRowIndex: null,

	snSummaryLoading: false,
	savingChanges: false,
	updateModalOpen: false,
	SNAllocationModalOpen: false,
	allocatingSNs: false,
	savingSerialNumbers: false,
	savingSuccess: false,
	showAllocationButton: false,

	snSummarySearchString: '',
	allocatingSNPercent: 0,
	lastBatchNumber: 0,
	serialAllocationErrors: [],

	allocatedSNList: [], // serial numbers assigned to the WO, must match quantity of parts on WO
	remainingSNList: [],
	snSummaryList: [], // all serial numbers for entire WO
	snRouteStageList: [], // serial numbers for a specific route stage, for updating (modal view)
	newSerialNumberStatus: '',
	snNewRouteStageList: [],
	
	snInProcessList: {}, // in process, by route stage
	snCompletedList: {}, // completed, by route stage

	opNum: '',
	routeName: '',
	routeDesc: '',
	routePrintedDesc: '',
	routeRev: '',
	errors: [],

	compRev: '',
	loadingWOStage: false,
};


export const types = {
    SET_STATE: 'WORKORDERSERIALNUM/SET_STATE',
	RESET_STATE: 'WORKORDERSERIALNUM/RESET_STATE',
	UPDATE_REMAINING_SN_LIST: 'WORKORDERSERIALNUM/UPDATE_REMAINING_SN_LIST',
	UPDATE_ROUTE_STAGE_SN_LIST: 'WORKORDERSERIALNUM/UPDATE_ROUTE_STAGE_SN_LIST',
	UPDATE_SERIAL_ALLOCATION_ERRORS: 'WORKORDERSERIALNUM/UPDATE_SERIAL_ALLOCATION_ERRORS',
};


export const reducers = (state = initialState, action) => {

	switch (action.type) {
		case types.SET_STATE:
			return { ...state, ...action.data };

		case types.RESET_STATE:
			return { ...initialState };

		case types.UPDATE_REMAINING_SN_LIST:
			return {
				...state,
				remainingSNList: [
					...state.remainingSNList.slice(0, action.index),
					{
						...state.remainingSNList[action.index],
						'U_TS_Allocated_Serial': action.data,
					},
					...state.remainingSNList.slice(action.index + 1),
				],
			}

		case types.UPDATE_ROUTE_STAGE_SN_LIST:
			return {
				...state,
				snRouteStageList: [
					...state.snRouteStageList.slice(0, action.index),
					{
						...state.snRouteStageList[action.index],
						[action.property]: action.value,
					},
					...state.snRouteStageList.slice(action.index + 1),
				],
			}

		case types.UPDATE_SERIAL_ALLOCATION_ERRORS:
			return {
				...state,
				serialAllocationErrors: [
					...state.serialAllocationErrors,
					action.data
				],
			}

		default:
			return state;
	}

};

export const actions = {
	setState: (data) => ({ type: types.SET_STATE, data }),

	resetState: () => ({ type: types.SET_STATE, data: { ...initialState }}),

	updateRemainingSNList: (data, index) => ({ type: types.UPDATE_REMAINING_SN_LIST, data, index}),

	updateSNRouteStageList: (value, property, index) => ({ type: types.UPDATE_ROUTE_STAGE_SN_LIST, value, property, index }),

	updateSerialAllocationErrors: (data) => ({ type: types.UPDATE_SERIAL_ALLOCATION_ERRORS, data }),
	
	loadWorkOrderAllocatedSNs: (docNum) => async (dispatch, getState) => {
		const state        = getState(),
			  isSerialized = state.workOrderReference.workOrderHeader.IsSerial === 'TRUE',
			  plannedQty   = state.workOrderReference.workOrderHeader.PlannedQty;

		dispatch(actions.setState({ snSummaryLoading: true }));

		try {
			const result = await api.get(`/workorders/workorder/${docNum}/serial_numbers/allocated`);

			let remainingSNList = [];
			if (isSerialized && result.serialNumbers.length !== parseInt(plannedQty)) {
				const difference = plannedQty - result.serialNumbers.length;
	
				for (let i=0; i<=difference - 1; i++) {
					remainingSNList.push({ 'U_TS_Allocated_Serial': '' });
				}
			}

			dispatch(actions.setState({ allocatedSNList: [ ...result.serialNumbers ] }));
			dispatch(actions.setState({ remainingSNList: [ ...remainingSNList ] }));
		} catch (e) {
			console.log(e);
		}

		dispatch(actions.setState({ snSummaryLoading: false }));
	},

	loadWorkOrderSNSummary: (docNum) => async (dispatch) => {
		dispatch(actions.setState({ snSummaryLoading: true }));

		try {
			const results = await api.get(`/workorders/workorder/${docNum}/serial_numbers/summary`);

			dispatch(actions.setState({ snSummaryList: [ ...results.serialNumSummary ] }));
			dispatch(actions.setState({ snCompletedList: results.completeSerialNumsByRouteStage }));
			dispatch(actions.setState({ snInProcessList: results.inProcessSerialNumsByRouteStage }));
		} catch (e) {
			console.log(e);
		}

		dispatch(actions.setState({ snSummaryLoading: false }));
	},

	loadWorkOrderStageSNs: (docNum, stageId) => async (dispatch) => {
		dispatch(actions.setState({loadingWOStage: true}));
		try {
			const results = await api.get(`/workorders/workorder/${docNum}/${stageId}/serial_numbers`);

			const routeStageSerialNums = results.routeStageSerialNums.map(((serialNumber, index) => {
				return {
					...serialNumber,
					key: index,
					isSelected: false,
				}
			}));
			
			dispatch(actions.setState({ snRouteStageList: [ ...routeStageSerialNums ]}));
		} catch (e) {
			console.log(e);
		}
		dispatch(actions.setState({loadingWOStage: false}));
	},

	workOrderSNAllocationCheck: (docNum) => async (dispatch, getState) => {		
		try {
			const results = await api.get(`/workorders/workorder/${docNum}/serial_numbers/test`);
			
			// if this check is false, there are serial numbers that still need to be allocated. Show user the allocation button.
			if (!results.allSNsAllocated) {
				dispatch(actions.setState({ showAllocationButton: true }));
				dispatch(actions.loadWorkOrderAllocatedSNs(docNum));
			} else {
				dispatch(actions.setState({ showAllocationButton: false }));
				dispatch(actions.workOrderSNDataCheck(docNum));
			}
		} catch(e) {
			console.log(e);
		}
	},
	// brings over list of all SN route combinations that do NOT already exist. 
	// Need to write ones that are missing into route SN table
	// DEFAULT STATUS IS PLANNED
	workOrderSNDataCheck: (docNum) => async (dispatch) => {
		try {
			const results = await api.get(`/workorders/workorder/${docNum}/serial_numbers/route_stage_check`);

			if (results.snStageData.length) {
				dispatch(actions.setState({ allocatingSNs: true }));
				dispatch(actions.writeSerialNumberRouteStageNew(docNum, results.snStageData));
			} else {
				// we did not find any serinal numbers missing stage assignment, so we can stop here
				dispatch(actions.loadWorkOrderAllocatedSNs(docNum));
				dispatch(actions.setState({ allocatingSNs: false }));
			}
			
		} catch(e) {
			console.log(e);
			dispatch(actions.setState({ allocatingSNs: false }));
		}
	},

	writeSerialNumberRouteStageNew: (docNum, serialNumbers) => async (dispatch, getState) => {
		const state        = getState(),
			  loggedEmpId  = state.workOrderReference.loggedEmpId,
			  employeeList = state.workOrderReference.employeeList;

		const employeeName   = employeeList.find(employee => employee.empID === loggedEmpId).Name || '',
			  resultPromises = [];
		/**
		 * i keeps track of how many requests we have made
		 * We are sending requests in sets of 10, so we divide our total by 10 to find the number of time we need to loop
		 */
		for (let i=0; i < (serialNumbers.length / 10); i++) {
			let len = serialNumbers.length - (i * 10);
			if (len > 10) {
				len = 10
			}
			let start = i * 10;
			let end = start + len;
	
			let serialNumberBatch = serialNumbers.slice(start, end);

			resultPromises.push(api.post(`/workorders/workorder/${docNum}/serial_numbers/add`, {
				employeeName,
				serialNumberBatch,
				batchNumber: i,
			}).then(result => {
				const lastBatchNumber = getState().workOrderSerialNum.lastBatchNumber;
				if (result.successful) {
					let currentBatchNumber = null;
					if (result.batchNumber < lastBatchNumber) {
						currentBatchNumber = lastBatchNumber
					} else {
						currentBatchNumber = result.batchNumber;
						dispatch(actions.setState({ lastBatchNumber: result.batchNumber }));
					}

					let newPercent = (currentBatchNumber / (serialNumbers.length/10)) * 100;

					dispatch(actions.setState({ allocatingSNPercent: newPercent }));
				} else {
					// do something to get this into an errors array to let user know!
					dispatch(actions.updateSerialAllocationErrors(result.error));
				}
			}));
		}

		Promise.all(resultPromises).then((results) => {
			// we are all done and this work order should be ready for the user
			dispatch(actions.loadWorkOrderAllocatedSNs(docNum));
			dispatch(actions.setState({ allocatingSNs: false }));
			dispatch(actions.setState({ showAllocationButton: false }));
		});
		
	},

	allocateNewSerialNumbers: () => async (dispatch, getState) => {
		const state         = getState(),
			  docNum        = state.workOrderReference.selectedWODocNum,
			  docEntry      = state.workOrderReference.workOrderHeader.DocEntry,
			  serialNumbers = state.workOrderSerialNum.remainingSNList;

		dispatch(actions.setState({ allocatingSNs: true }));

		// filter out any the user didn't fill in so they don't get written
		const serialNumbersToWrite = serialNumbers.filter(value => value.U_TS_Allocated_Serial !== '');

		try {
			await api.post(`/workorders/workorder/${docEntry}/serial_numbers/allocate`, {
				docNum,
				serialNumbers: serialNumbersToWrite
			});

			dispatch(actions.workOrderSNDataCheck(docNum));
		} catch (e) {
			console.log(e)
			dispatch(actions.setState({ allocatingSNs: false }));
		}
	},

	writeSerialNumberRouteStageUpdate: () => async (dispatch, getState) => {
		const state                 = getState(),
			  loggedEmpId           = state.workOrderReference.loggedEmpId,
			  employeeList          = state.workOrderReference.employeeList,
			  docNum                = state.workOrderReference.selectedWODocNum,
			  currentStageID        = state.workOrderSerialNum.currentStageID,
			  newSerialNumberStatus = state.workOrderSerialNum.newSerialNumberStatus,
			  snRouteStageList      = state.workOrderSerialNum.snRouteStageList,
			  compRev               = state.workOrderSerialNum.routeRev;

		dispatch(actions.setState({ savingSerialNumbers: true }));

		const employeeName          = employeeList.find(employee => employee.empID === loggedEmpId).Name || '',
			  serialNumbersToUpdate = snRouteStageList.filter(serialNumber => serialNumber.isSelected);

			dispatch(actions.setState({ errors: [] }));
			if(serialNumbersToUpdate.length) {
				try {
	
					serialNumbersToUpdate.forEach(obj => {
						obj.completedRev = compRev;
						obj.newStatus    = newSerialNumberStatus;
					});

					const result = await api.put(`/workorders/workorder/${docNum}/serial_numbers/update`, {
						employeeName,
						serialNumbers: serialNumbersToUpdate,
					});

					if (result.success) {
						await dispatch(actions.loadWorkOrderStageSNs(docNum, currentStageID));
						await dispatch(actions.checkStageStatus());
					}
				} catch(e) {
					console.log(e);
					dispatch(actions.setState({ savingSerialNumbers: false }));
					dispatch(actions.setState({ savingSuccess: false }));
				}
			} else {
				dispatch(actions.setState({ savingSuccess: false }));
				dispatch(actions.setState({ savingSerialNumbers: false }));
				dispatch(actions.setState({ errors: ['Please select which serial number route stage to update.']}));
			}
	},

	checkStageStatus: () => async (dispatch, getState) => {
		const state             = getState(),
			  docNum            = state.workOrderReference.selectedWODocNum,
			  currentStageID    = state.workOrderSerialNum.currentStageID,
			  woRouteStageList  = state.workOrderReference.stagesList,
			  currentRouteStage = woRouteStageList.filter(stage => stage.StageID === currentStageID)[0];

		const result = await api.get(`/workorders/workorder/${docNum}/${currentStageID}/serial_numbers/check_status`, {
			routeStageID: currentStageID
		})

		currentRouteStage['Status'] = result.newRouteStatus;

		// replace with route stage returned from query
		await dispatch(stageTableActions.updateStagingRequest(0, currentRouteStage)); // index is zero since we know we are only changing single route stage
		await dispatch(stageTableActions.submitStageChange());

		await dispatch(actions.loadWorkOrderSNSummary(docNum));
		dispatch(actions.setState({ savingSuccess: true }));
		dispatch(actions.setState({ savingSerialNumbers: false }));
	}
};
